import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Client, ClientsData} from "@core/services/backend/common/interface/clients";
import {ClientsApi} from "@core/services/backend/common/api/clients.api";

@Injectable()
export class ClientsService extends ClientsData {
    constructor(private api: ClientsApi) {
        super();
    }

    list(search: string, pageNumber: number, pageSize: number, orderBy: string): Observable<any[]> {
        return this.api.list(search, pageNumber, pageSize, orderBy);
    }

    get(id: number): Observable<Client> {
        return this.api.get(id);
    }

    create(client: any): Observable<Client> {
        return this.api.add(client);
    }

    update(client: any): Observable<Client> {
        return this.api.update(client);
    }

    delete(client: any): Observable<Client> {
        return this.api.delete(client);
    }
}

